import { Sheets } from "common/sheets";
export class Title {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, "title");
        this.sprite.animationSpeed = 0.1;
    }
}
//# sourceMappingURL=title.js.map